/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Qwick Core API
 * AKA V3, AKA Gigpro, AKA sidegig-api
 * OpenAPI spec version: 0.0.0
 */

/**
 * * `PRESET` - Preset
 * * `CUSTOM` - Custom
 * * `NOT_REQUIRED` - Not Required
 */
export type UniformSelectionWriteSelectionTypeEnum = typeof UniformSelectionWriteSelectionTypeEnum[keyof typeof UniformSelectionWriteSelectionTypeEnum];


export const UniformSelectionWriteSelectionTypeEnum = {
  PRESET: 'PRESET',
  CUSTOM: 'CUSTOM',
  NOT_REQUIRED: 'NOT_REQUIRED',
} as const;
